/* tslint:disable:object-literal-sort-keys */
import { unmarshal as defaultUmarshal } from '@ogury/unmarshaller';
import { getLocale } from '../translator';
import { builder } from './builder';
import { constants, units } from './constants';
import { contentDiscoveryConfig } from './content-discovery';
import { recommendedLinksConfig } from './recommended-links';

export { builder, constants };

export function displayTrackersConfig() {
  return builder.holder({
    trackers: builder.string('display_trackers', {
      defaultValue: '',
      d:''
    }),
    omidTrackers: builder.string('omid_trackers', {
      defaultValue: '',
      d:''
    }),
    omidTrackingEnabled: builder.boolean('omid_tracking_enabled', {
      defaultValue: false,
      d:''
    }),
    allowAgnosticTracking: builder.boolean('allow_display_agnostic_tracking', {
      defaultValue: false,
      d:''
    }),
    inhouse: builder.boolean('display_tracker_ogury', {
      defaultValue: false,
      d:''
    }),
    htmlContainerSelector: builder.string('dt_force_html_container', {
      defaultValue: '',
      d:''
    }),
    scriptContainerSelector: builder.string('dt_force_script_container', {
      defaultValue: '',
      d:''
    }),
    overloadDocumentWrite: builder.boolean('dt_overload_document_write', {
      defaultValue: true,
      d:''
    }),
    enableSentryLog: builder.boolean('dt_enable_sentry_log', {
      defaultValue: true,
      d:''
    })
  });
}

export function flattenConfig(
  unmarshaller: UnmarshallerBuilder
): Array<UnmarshallerObject<any>> {
  const keys = Object.keys(unmarshaller);

  return keys.reduce((acc: any[], k: string) => {
    const config = (unmarshaller as any)[k];

    if (config.type === 'holder' || config.type === 'or') {
      return [...acc, ...flattenConfig(config.children)];
    }

    acc.push(config);

    return acc;
  }, []);
}

export function extractAvailableParams(unmarshaller: UnmarshallerBuilder) {
  return flattenConfig(unmarshaller).map(
    (e: UnmarshallerObject<any>) => e.name
  );
}

export const defaults = {
  watermarkApiKeys: builder.csv('watermark_api_keys', {
    defaultValue: ['apikey-watermark'],
    d:''
  }),
  analytics: builder.holder({
    enable: builder.boolean('analytics_enable', {
      l:'',
      d:'',
      defaultValue: false
    })
  }),
  watermarkPosition: builder.string('watermark_position', {
    of: ['bottom-left', 'bottom-right'],
    defaultValue: 'bottom-left',
    d:''
  }),
  browser: builder.holder({
    type: builder.string('browser', {
      possibleValues: [
        {
          name: 'Ogury browser',
          value: 'browser',
          comment: 'Internal delivery only'
        },
        {
          name: 'Default browser',
          value: 'defaultbrowser'
        }
      ],
      defaultValue: 'defaultbrowser',
      l:'',
      d:''
    }),
    preload: builder.boolean('browser_enable_preload', {
      defaultValue: true
    })
  }),
  displayTrackers: displayTrackersConfig(),
  mrc50ImgTrackers: builder.array('mrc50_img_trackers', {
    optional: true
  }),
  mrc50JsTrackers: builder.array('mrc50_js_trackers', {
    optional: true
  }),
  mrc100ImgTrackers: builder.array('mrc100_img_trackers', {
    optional: true
  }),
  mrc100JsTrackers: builder.array('mrc100_js_trackers', {
    optional: true
  }),
  interaction: builder.string('interaction', {
    of: ['touch', 'click'],
    defaultValue: 'touch',
    l:'',
    d:''
  }),
  locale: builder.string('locale', {
    l:'',
    d:'',
    defaultValue: getLocale() || 'en',
    of: [
      'auto',
      'fr',
      'en',
      'it',
      'de',
      'pt',
      'es',
      'ja',
      'ru',
      'nl',
      'sv',
      'da',
      'pl',
      'cs',
      'nb',
      'fi',
      'ar'
    ]
  }),
  sdkVersion: builder.string('sdk_version', {
    l:'',
    d:'',
    optional: true
  }),
  odid: builder.string('odid', {
    l:'',
    d:'',
    optional: true
  }),
  application: builder.object('application', {
    d:'',
    defaultValue: {}
  }),
  recommendedLinks: recommendedLinksConfig,
  contentDiscovery: contentDiscoveryConfig,
  omid: builder.holder({
    trackingEnabled: builder.boolean('omid_tracking_enabled', {
      defaultValue: false,
      d:''
    }),
    trackers: builder.string('omid_trackers', {
      defaultValue: '',
      d:''
    }),
    enableOgyTag: builder.boolean('enable_omid_tag', {
      defaultValue: true,
      l:''
    }),
    impressionDelay: builder.number('omid_impression_delay', {
      defaultValue: 250,
      unit: units.milliseconds
    })
  }),
  closeBtnOffsetY: builder.number('close_btn_offset_y', {
    defaultValue: 0,
    d:'',
    unit: units.pixel
  })
};

// TODO TS : this ad: any should be replaced by something int MountTestHelper.tsx when it will be typed
export function unmarshal(
  ad: any,
  unmarshaller: Array<UnmarshallerObject<string>>
) {
  return defaultUmarshal(ad.getParam.bind(ad), unmarshaller);
}
